import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/servico-tipo',
  name: 'servico-tipo',
  component: Index,
  children: [
    { path: 'listar', name: 'servico-tipo-listar', component: Listar },
    { path: 'novo', name: 'servico-tipo-novo', component: Novo },
    { path: ':id', name: 'servico-tipo-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'servico-tipo-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/servico-tipo/routes.js